<template>
  <vs-popup class="popup-q-r-history" title="QR 참석자 명단 가져오기" :active.sync="showPopup">
    <div>
      <div class="flex items-center gap-2">
        <search-date label="스캔일시" v-model="date" :readonly="!!searchDate" @input="applySearch" />
        <div class="flex gap-4 items-center">
          <span class="title">회사명</span>
          <field-selector class="w-full" :value="field.field_id" :field-name="field.field_name" readonly />
        </div>
      </div>

      <vs-select class="mt-6" v-model="perPage" autocomplete style="width: 120px" @change="applySearch">
        <vs-select-item v-for="i in [10, 20, 50, 100]" :key="i" :text="`${i}개씩 보기`" :value="i" />
      </vs-select>

      <div class="mt-4">
        <vs-table class="w-full mb-4" stripe :sst="true" :max-items="perPage" :data="list" :multiple="true" v-model="selected" noDataText="데이터가 없습니다">
          <template slot="thead">
            <vs-th><span class="w-full text-center">No.</span></vs-th>
            <vs-th><span class="w-full text-center">스캔일시</span></vs-th>
            <vs-th><span class="w-full text-center">장비명</span></vs-th>
            <vs-th><span class="w-full text-center">규격</span></vs-th>
            <vs-th><span class="w-full text-center">장비번호</span></vs-th>
            <vs-th><span class="w-full text-center">장비운전자</span></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="(tr, tr_i) in data" :key="`popup-q-r-history-${tr_i}`" :data="tr">
              <vs-td align="center">{{ total - ((loadedPage - 1) * perPage + tr_i) }}</vs-td>
              <vs-td align="center">{{ tr["스캔일자"] }}</vs-td>
              <vs-td align="center">{{ tr["장비명"] }}</vs-td>
              <vs-td align="center">{{ tr["장비규격"] }}</vs-td>
              <vs-td align="center">{{ tr["장비번호"] }}</vs-td>
              <vs-td align="center">{{ tr["장비운전자"] }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="lastPage ? lastPage : 1" v-model="page" @change="onChangePage"></k-pagination>
        </div>
      </div>

      <div class="mt-8 flex justify-end gap-4">
        <vs-button color="secondary" type="border" @click="onClickClose">닫기</vs-button>
        <vs-button color="secondary" @click="onClickUse">등록</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";
import SearchNav from "@/components/nav/SearchNav.vue";
import TimeSelectorRang from "@/components/selector/TimeSelectorRang.vue";
import SearchStartEnd from "@/views/list/components/SearchStartEnd.vue";
import SearchDate from "@/views/list/components/SearchDate.vue";
import SearchSelect from "@/views/list/components/SearchSelect.vue";
import SearchKeyword from "@/views/list/components/SearchKeyword.vue";
import SearchTimeStartEnd from "@/views/list/components/SearchTimeStartEnd.vue";
import KPagination from "@/components/kPagination/kPagination.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  name: "PopupQRHistoryEquipment",
  components: {
    FieldSelector,
    KPagination,
    SearchTimeStartEnd,
    SearchKeyword,
    SearchSelect,
    SearchDate,
    SearchStartEnd,
    TimeSelectorRang,
    SearchNav,
  },
  props: {
    value: Boolean,
    projectId: Number,
    searchDate: String,
    searchField: Object,
  },
  computed: {
    showPopup: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    projId() {
      return this.projectId || this.$store.state.project.projectId;
    },
    optionFields() {
      return [
        { value: 0, text: "전체" },
        ...this.regions.map((item) => {
          return {
            text: item.name,
            value: item.id,
          };
        }),
      ];
    },
    memberInfo() {
      return this.$store.state.member.memberInfo;
    },
  },
  watch: {
    value(value) {
      if (value) {
        // 한국 시간으로 오늘 날짜
        this.date = new Date(this.searchDate).format("yyyy-MM-dd");
        this.field = this.searchField;
        this.page = 1;
        this.perPage = 10;
        this.keyword = "";
        this.loadHistory();
        this.loadRegionList();
      }
    },
  },
  data() {
    return {
      page: 1,
      loadedPage: 1,
      perPage: 20,
      lastPage: 1,
      total: 0,
      date: "",
      time: {
        startTime: "00:00:00",
        endTime: "23:59:59",
      },
      region: 0,
      zoneName: "",
      scanData: "",
      userComName: "",
      list: [],
      selected: [],
      regions: [],
      isMyScans: true,
      scannerName: "",
      field: {},
    };
  },

  methods: {
    formatDate(date, format = "yyyy-MM-dd") {
      if (!date) return "";
      const d = new Date(date);
      if (isNaN(d.getTime())) return "";

      // 간단한 날짜 포맷팅 함수
      const pad = (num) => String(num).padStart(2, "0");

      return format
        .replace("yyyy", d.getFullYear())
        .replace("MM", pad(d.getMonth() + 1))
        .replace("dd", pad(d.getDate()))
        .replace("HH", pad(d.getHours()))
        .replace("mm", pad(d.getMinutes()))
        .replace("ss", pad(d.getSeconds()));
    },

    applySearch() {
      this.page = 1;
      this.loadHistory();
    },
    loadHistory() {
      const options = {
        params: {
          page: this.page,
          perPage: this.perPage,
          projectId: this.projId,
          type: "identity",
          boardId: 1040,
          //fieldId
          //postId
          //regionId
          //zoneId
          //scannerUerId
          //dateFrom
          //dateTo
          //scannerUserId
        },
      };

      // if (this.scannerName) {
      //   options.params.scannerName = this.scannerName;
      // }
      //
      const date = this.date;
      if (date) {
        const dateFrom = new Date(date);
        const startTime = this.time.startTime;
        const endTime = this.time.endTime;
        options.params.dateFrom = dateFrom.format(`yyyy-MM-dd ${startTime || '00:00:00'}`)
        if (endTime) {
          options.params.dateTo = dateFrom.format(`yyyy-MM-dd ${endTime}`);
        } else {
          options.params.dateTo = new Date(dateFrom.setDate(dateFrom.getDate() + 1)).format("yyyy-MM-dd 00:00:00");
        }
      }

      if (this.field && this.field.id) {
        options.params.regionId = this.field.id;
      }

      HttpRequest.get("/api/v1/project/qr/history/list", options)
        .then((res) => {
          console.log("QR 스캔 목록 조회:", res);

          const userIds = []
          res.data.forEach(item => {
            if (item.user_id && !userIds.includes(item.user_id)) {
              userIds.push(item.user_id);
            }
          });
          if (userIds.length > 0) {
            this.loadMemberListInfo(userIds)
              .then((result) => {
                console.log("Member list loaded:", result);
                this.list = this.convertList(res.data, result.data);
              })
              .catch((err) => {
                console.error("Error loading member list:", err);
              });
          } else {
            this.list = this.convertList(res.data);
          }

          this.total = res.total;
          this.lastPage = res.last_page;
          this.loadedPage = this.page;
        })
        .catch((err) => {
          console.error("QR 스캔 목록 조회 오류:", err);
        });
    },

    async loadMemberListInfo(userIds) {
      console.log('Loading member list for user IDs:', userIds);
      return await HttpRequest.get("/api/v1/member", {
        params: {
          projectId: this.$route.params.proj_id,
          userIds,
          page: 1,
          perPage: 10000,
        },
      })

    },

    convertList(responseData, memberList = []) {

      return responseData.map((responseItem) => {

        // responseData의 user_id와 일치하는 memberList 항목 찾기
        const memberItem = memberList.find(member => member.id === responseItem.user_id);
console.log('member', memberItem)
        let 장비명 = '';
        let 장비규격 = '';
        let 장비번호 = '';
        let 장비운전자 = '';

        if (memberItem && memberItem.metas && memberItem.metas.length > 0) {
          const 장비명Meta = memberItem.metas.find(meta => meta.meta_key === '장비명');
          const 장비명직접입력 = memberItem.metas.find(meta => meta.meta_key === '장비명_직접입력');
          const 장비규격Meta = memberItem.metas.find(meta => meta.meta_key === '장비규격');
          const 장비규격직접입력 = memberItem.metas.find(meta => meta.meta_key === '장비규격_직접입력');
          const 장비번호Meta = memberItem.metas.find(meta => meta.meta_key === '장비번호');
          const 장비운전자Meta = memberItem.metas.find(meta => meta.meta_key === '장비운전자');

          장비명 = 장비명Meta ? 장비명Meta.meta_value : '';
          if (장비명 === '직접입력') {
            장비명 = 장비명직접입력 ? 장비명직접입력.meta_value : '';
          }
          장비번호 = 장비번호Meta ? 장비번호Meta.meta_value : '';
          장비규격 = 장비규격Meta ? 장비규격Meta.meta_value : '';
          if (장비규격 === '직접입력') {
            장비규격 = 장비규격직접입력 ? 장비규격직접입력.meta_value : '';
          }
          장비운전자 = 장비운전자Meta ? 장비운전자Meta.meta_value : '';

        }

        return {
          스캔일자: this.formatDate(responseItem.created_at),
          user_id: memberItem.id,
          장비명: 장비명 || "-",
          장비규격: 장비규격 || "-",
          장비번호: 장비번호 || "-",
          장비운전자: 장비운전자 || "-",
          연락처: memberItem.phone || memberItem.mobile || "-",
          부서: memberItem.company.com_name || "-",
        }
      });
    },

    loadRegionList() {
      const option = {
        params: {
          page: 1,
          perPage: 20,
          keyword: "", // 검색이 필요할 경우 사용,
        },
      };
      // keyword 를 사용하지 않을 경우 삭제
      if (option.params.keyword === "") {
        delete option.params.keyword;
      }

      // const api = '/api/v1/region';
      // HttpRequest.get(api, option)
      //   .then(response => {
      //     const data = response.data;
      //     this.regions = data;
      //   }).catch(err => {  })
    },

    getCompany(item) {
      let company = "";
      if (item.user && item.user.company) {
        company += item.user.company.com_name || "-";
      }
      return company;
    },

    onChangePage(page) {
      if (this.value) {
        this.loadHistory();
      }
    },

    onClickClose() {
      this.showPopup = false;
    },

    onClickUse() {
      this.$emit("select", this.selected);
      this.onClickClose();
    },
  },
};
</script>

<style scoped lang="scss">
.popup-q-r-history::v-deep {
  .vs-popup {
    width: 1500px !important;
    max-width: 90% !important;
  }

  .title {
    font-weight: 500;
    line-height: 38px;
    text-align: left;
    white-space: nowrap;

    @media (max-width: 1200px) {
      width: 80px !important;
    }
  }
}
</style>


